import ReactDOM from 'react-dom/client';
import App from './App';
import 'common/styles/index.scss';
import { analytics } from 'common/services/analytics/Analytics';
import { initSentry } from 'common/config/sentry';
import { SentryErrorBoundary } from 'common/components/SentryErrorBoundary/SentryErrorBoundary';
import { ProjectType } from 'common/types';

const { VITE_AMPLITUDE_API_KEY } = import.meta.env;

initSentry(ProjectType.APP);

analytics.initApp(VITE_AMPLITUDE_API_KEY);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <SentryErrorBoundary>
    <App />
  </SentryErrorBoundary>,
);
